
import React from "react";
import { User } from "@/types";
import { ChildCard } from "./ChildCard";

interface ChildListProps {
  children: User[];
  onRemoveChild: (childId: string) => void;
  onUpdateChild: (childId: string, firstName: string, lastName: string) => Promise<void>;
}

export function ChildList({ children, onRemoveChild, onUpdateChild }: ChildListProps) {
  if (children.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">No family members added yet.</p>
      </div>
    );
  }

  // Separate children and parents for better organization
  const childMembers = children.filter(member => member.role === 'child');
  const parentMembers = children.filter(member => member.role === 'parent');

  return (
    <div className="space-y-8">
      {parentMembers.length > 0 && (
        <div>
          <h2 className="text-xl font-semibold mb-4">Parents</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {parentMembers.map((member) => (
              <ChildCard 
                key={member.id} 
                child={member} 
                onRemove={onRemoveChild} 
                onUpdateChild={onUpdateChild}
              />
            ))}
          </div>
        </div>
      )}
      
      {childMembers.length > 0 && (
        <div>
          <h2 className="text-xl font-semibold mb-4">Children</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {childMembers.map((child) => (
              <ChildCard 
                key={child.id} 
                child={child} 
                onRemove={onRemoveChild} 
                onUpdateChild={onUpdateChild}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
